import { observer } from 'mobx-react';
import { ElementState, ContainerStateBase } from '@/elements/base/ElementState';
import { getUIElementComponent, getContainerUIElementComponent } from '@/elements/elementStorage';

export const ElementRenderer = observer(function ElementRenderer({ state }: { state: ElementState }) {
  if (state instanceof ContainerStateBase) {
    const Component = getContainerUIElementComponent(state.elementKind, state.elementType);
    return <Component viewElement={state.viewElement} childrenItems={state.children} />;
  }

  const Component = getUIElementComponent(state.elementKind, state.elementType);
  return <Component state={state} />;
});
